import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AccountService } from '../../../api';
import { ToastService } from '../../../../shared/service/toast.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {
  passwordForm: FormGroup;
  loading = false;
  email;
  constructor(
    public activeModal: NgbActiveModal,
    private as: AccountService,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.passwordForm = new FormGroup({
      password: new FormControl({ value: '', disabled: false }),
      repassword: new FormControl({ value: '', disabled: false }),
      mail: new FormControl(false),
      generate: new FormControl(false)
    }, validPassword);
  }

  get password() { return this.passwordForm.get('password'); }
  get repassword() { return this.passwordForm.get('repassword'); }
  get generate() { return this.passwordForm.get('generate'); }
  get mail() { return this.passwordForm.get('mail'); }

  checkForm() {
    if (!this.generate.value) {
      this.passwordForm.controls.password.reset();
      this.passwordForm.controls.password.disable();
      this.passwordForm.controls.repassword.reset();
      this.passwordForm.controls.repassword.disable();
      this.passwordForm.controls.mail.disable();
      this.passwordForm.get('mail').setValue(true);
    } else {
      this.passwordForm.controls.password.enable();
      this.passwordForm.controls.repassword.enable();
      this.passwordForm.controls.mail.enable();
    }
  }
  closeModal() {
    this.activeModal.dismiss();
  }
  saveModal() {
    const data = {
      email: this.email,
      password: this.password.value,
      autoGeneratePassword: this.generate.value,
      sendPasswordToEmail: this.mail.value
    };
    this.loading = true;
    this.as.apiAccountsChangepwFromSPPut(data)
      .subscribe(dt => {
        this.toast.showSuccess('PASSWORD_CHANGE_SUCCESS');
        this.activeModal.close();
      }, error => {
        this.loading = false;
      });
  }
}

function validPassword(form: FormGroup): { [key: string]: boolean } {
  if (!form.get('generate').value) {
    if (!form.get('password').value) {
      return { 'invalidPassword': true };
    } else {
      if (form.get('password').value.length < 6 || form.get('password').value.length > 100) {
        return { 'invalidPassword': true };
      }
      if (form.get('password').value !== form.get('repassword').value) {
        return { 'invalidRepassword': true };
      }
    }
  }
  return null;
}
